<div class="cfd-principal">
  <header class="cfd-header">
    <span class="cfd-header-icone">
      <mat-icon class="material-symbols-outlined">{{ isVolumes ? 'local_shipping' : 'checklist' }}</mat-icon>
    </span>
    <div class="cfd-header-texto">
      <h2 class="cfd-titulo">{{ titulo }}</h2>
      <div class="cfd-subtitulo">{{ identificacao }} · {{ subtitulo }}</div>
    </div>
    @if (data.isCega) {
    <span class="status-badge badge-oliva cfd-pilula">
      <mat-icon class="material-symbols-outlined">visibility_off</mat-icon>MODO CEGO
    </span>
    }
    <button mat-icon-button type="button" class="cfd-header-btn icon-mat-symbols-btn" (click)="alternarTamanho()"
      [matTooltip]="isMaximizado ? 'Restaurar' : 'Maximizar'" [attr.aria-label]="isMaximizado ? 'Restaurar' : 'Maximizar'">
      <mat-icon class="material-symbols-outlined">{{ isMaximizado ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
    <button mat-icon-button type="button" class="cfd-header-btn icon-mat-symbols-btn" (click)="cancelar()" [disabled]="ocupado"
      matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </header>

  <div class="cfd-info">
    <div class="cfd-info-campo">
      <div class="cfd-info-rotulo">Nota de entrada</div>
      <div class="cfd-info-valor">{{ numeroNota }}</div>
    </div>
    <div class="cfd-info-campo">
      <div class="cfd-info-rotulo">Emissão</div>
      <div class="cfd-info-valor">{{ (data.nota?.dataEmissao | date: 'dd/MM/yyyy') || '—' }}</div>
    </div>
    <div class="cfd-info-campo">
      <div class="cfd-info-rotulo">Remetente</div>
      <div class="cfd-info-valor">{{ data.nota?.nomeEmitente || '—' }}</div>
    </div>
  </div>

  <mat-dialog-content class="cfd-conteudo">
    @if (!isVolumes && !data.somenteLeitura) {
    <div class="cfd-busca">
      <mat-form-field appearance="outline" class="cfd-busca-termo">
        <mat-label>Buscar por SKU, EAN ou descrição</mat-label>
        <input #campoBusca matInput type="text" autocomplete="off" [ngModel]="termoBusca"
          (ngModelChange)="onTermoBuscaChange($event)" (keydown.enter)="lancarBusca()"
          [disabled]="ocupado" placeholder="Bipe ou digite o SKU ou a descrição">
        <mat-icon matSuffix class="material-symbols-outlined">qr_code_scanner</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline" class="cfd-busca-quantidade">
        <mat-label>Quantidade</mat-label>
        <input matInput type="text" inputmode="numeric" placeholder="Opcional" [currencyMask]="quantidadeMask"
          [(ngModel)]="quantidadeBusca" (keydown.enter)="lancarBusca()" [disabled]="ocupado">
      </mat-form-field>
    </div>
    <p class="cfd-apoio">Suporta leitor de código de barras: bipe o item e informe a quantidade para lançar direto na contagem.</p>
    }

    @if (isVolumes) {
    <div class="cfd-volumes">
      <span class="cfd-volumes-icone">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
      </span>
      <div class="cfd-volumes-texto">
        <div class="cfd-volumes-titulo">Volumes recebidos</div>
        <div class="cfd-volumes-apoio">{{ textoVolumes }}</div>
      </div>
      <app-contador-quantidade [value]="volumesRecebidos" (valueChange)="definirVolumes($event)" [mask]="quantidadeMask"
        [readonly]="data.somenteLeitura" [disabled]="ocupado" ariaLabel="Volumes recebidos"></app-contador-quantidade>
    </div>
    } @else {
    <div class="cfd-tabela" [class.cfd-tabela--esperado]="exibeEsperado">
      <div class="cfd-linha cfd-linha--cabecalho">
        <span>Descrição</span>
        <span>Código (SKU)</span>
        <span>UN</span>
        @if (exibeEsperado) { <span class="cfd-num">Esperado</span> }
        <span class="cfd-num">Contagem</span>
        <span class="cfd-status-col">{{ data.somenteLeitura ? 'Situação' : '' }}</span>
      </div>
      @for (item of itensVisiveis; track item.idConferenciaItem) {
      <div class="cfd-linha" [attr.data-item]="item.idConferenciaItem"
        [class.cfd-linha--destaque]="item.idConferenciaItem === idItemDestaque">
        <span class="cfd-descricao" [matTooltip]="item.nome">{{ item.nome }}</span>
        <span class="cfd-secundario"><span class="cfd-rotulo-mobile">SKU </span>{{ item.codigoSku || '—' }}</span>
        <!-- Sem rótulo no mobile: a unidade já se explica ("SKU 2 · UN"); com rótulo virava "UN UN". -->
        <span class="cfd-secundario">{{ item.unidade || '—' }}</span>
        @if (exibeEsperado) {
        <span class="cfd-secundario cfd-num">
          <span class="cfd-rotulo-mobile">Esperado </span>{{ item.quantidadeEsperada == null ? '—' : (item.quantidadeEsperada | number: '1.0-4') }}
        </span>
        }
        <app-contador-quantidade class="cfd-contagem" [value]="item.quantidadeConferida" (valueChange)="definirItem(item, $event)"
          [mask]="quantidadeMask" [readonly]="data.somenteLeitura" [disabled]="ocupado" [compact]="true"
          [ariaLabel]="'Contagem de ' + item.nome" [ariaContexto]="item.nome"></app-contador-quantidade>
        <span class="cfd-status-col">
          @if (data.somenteLeitura) {
            @switch (item.idStatusItemConferencia) {
              @case (statusItem.Conforme) { <span class="status-badge badge-verde">Conforme</span> }
              @case (statusItem.Divergente) { <span class="status-badge badge-vermelho">Divergente</span> }
              @default { <span class="status-badge badge-cinza">Pendente</span> }
            }
          } @else {
            <span class="cfd-ponto" [ngClass]="classePonto(item)" [matTooltip]="tooltipPonto(item)"
              [attr.aria-label]="tooltipPonto(item)"></span>
          }
        </span>
      </div>
      } @empty {
      <div class="cfd-vazio">Nenhum item para conferir.</div>
      }
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="cfd-rodape">
    <span class="cfd-rodape-texto">{{ textoRodape }}</span>
    @if (!data.somenteLeitura) {
    <span [matTooltip]="motivoRegistrarProblema" [matTooltipDisabled]="!motivoRegistrarProblema">
      <button mat-stroked-button type="button" class="btn-filter" (click)="abrirProblema()"
        [disabled]="!data.podeRegistrarProblema || ocupado || problemaAberto">
        <mat-icon class="material-symbols-outlined">report</mat-icon>
        Registrar problema
      </button>
    </span>
    }
    <button mat-stroked-button type="button" class="btn-secondary btn-spinner" [class.btn-loading]="fechando"
      [disabled]="ocupado" [attr.aria-label]="data.somenteLeitura ? 'Fechar' : 'Cancelar'" (click)="cancelar()">
      {{ data.somenteLeitura ? 'Fechar' : 'Cancelar' }}
      @if (fechando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
    @if (!data.somenteLeitura) {
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="concluindo"
      [disabled]="ocupado" aria-label="Concluir contagem" (click)="concluir()">
      <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
      Concluir contagem
      @if (concluindo) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
    }
  </mat-dialog-actions>
</div>

@if (problemaAberto) {
<aside class="cfd-problema" aria-label="Registrar problema">
  <header class="cfd-header">
    <span class="cfd-header-icone">
      <mat-icon class="material-symbols-outlined">report</mat-icon>
    </span>
    <div class="cfd-header-texto">
      <h2 class="cfd-titulo">Registrar problema</h2>
      <div class="cfd-subtitulo">Nota de entrada {{ numeroNota }}</div>
    </div>
    <button mat-icon-button type="button" class="cfd-header-btn icon-mat-symbols-btn" (click)="fecharProblema()" [disabled]="salvandoProblema"
      matTooltip="Fechar" aria-label="Fechar painel">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </header>

  <div class="cfd-problema-conteudo">
    <div class="cfd-problema-rotulo">Qual é o problema</div>
    <mat-radio-group class="cfd-problema-tipos" [(ngModel)]="problemaTipo" [disabled]="salvandoProblema" aria-label="Tipo do problema">
      <mat-radio-button [value]="tipoDivergencia.Quantidade">Divergência nas quantidades</mat-radio-button>
      <mat-radio-button [value]="tipoDivergencia.Avaria">Volume com avaria</mat-radio-button>
    </mat-radio-group>

    @if (!isVolumes) {
    <mat-form-field appearance="outline" class="cfd-campo">
      <mat-label>Item</mat-label>
      <mat-select [(ngModel)]="problemaIdItem" [disabled]="salvandoProblema">
        <mat-option [value]="null">Nenhum item específico</mat-option>
        @for (item of itens; track item.idConferenciaItem) {
        <mat-option [value]="item.idConferenciaItem">{{ item.codigoSku ? item.codigoSku + ' - ' : '' }}{{ item.nome }}</mat-option>
        }
      </mat-select>
      <mat-hint>Opcional.</mat-hint>
    </mat-form-field>
    }

    @if (!problemaIdItem) {
    <mat-form-field appearance="outline" class="cfd-campo">
      <mat-label>Referência</mat-label>
      <input matInput type="text" maxlength="200" [(ngModel)]="problemaReferencia" [disabled]="salvandoProblema">
      <mat-hint>{{ isVolumes ? 'Identificação do volume, como a etiqueta ou o número da caixa.' : 'Opcional.' }}</mat-hint>
    </mat-form-field>
    }

    <mat-form-field appearance="outline" class="cfd-campo">
      <mat-label>Quantidade com problema</mat-label>
      <input matInput type="text" inputmode="numeric" [currencyMask]="quantidadeProblemaMask"
        [(ngModel)]="problemaQuantidade" [disabled]="salvandoProblema">
    </mat-form-field>

    <mat-form-field appearance="outline" class="cfd-campo">
      <mat-label>Descreva o problema</mat-label>
      <textarea matInput rows="5" [(ngModel)]="problemaDescricao" [disabled]="salvandoProblema"></textarea>
    </mat-form-field>
  </div>

  <div class="cfd-problema-rodape">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fecharProblema()" [disabled]="salvandoProblema">Cancelar</button>
    <span [matTooltip]="motivoSalvarProblema" [matTooltipDisabled]="!motivoSalvarProblema">
      <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="salvandoProblema"
        [disabled]="salvandoProblema || !!motivoSalvarProblema" aria-label="Salvar problema" (click)="salvarProblema()">
        <mat-icon class="material-symbols-outlined">check</mat-icon>
        Salvar
        @if (salvandoProblema) { <mat-spinner diameter="20"></mat-spinner> }
      </button>
    </span>
  </div>
</aside>
}
